/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ScheduleType } from '@gh/builder-shared-data';
import {
  AbstractSnapshotFormComponent,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
} from '@gh/common-shared';
import { ScheduleMasterInfo } from '../../../resources/schedule-details.model';

@Component({
  standalone: false,
  selector: 'gh-pre-main-schedule-details-top-form',
  templateUrl: 'pre-main-schedule-details-top-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreMainScheduleDetailsTopFormComponent
  extends AbstractSnapshotFormComponent<ScheduleMasterInfo> {
  @Input() type: ScheduleType;
  @Input() startDate: Date;
  @Input() endDate: Date;
  @Input() duration: number;

  get namePlaceholder(): string {
    return {
      [ScheduleType.PreConstruction]: 'lbl_pre_construction_sch',
      [ScheduleType.Maintenance]: 'lbl_maintenance_sch',
    }[this.type];
  }

  constructor(private formStateBuilder: FormStateBuilder) {
    super();
  }

  protected buildForm(snapshot: FormStateSnapshot<ScheduleMasterInfo>): FormState<ScheduleMasterInfo> {
    return this.formStateBuilder.buildPlain({
      enabled: this.enabled,
      snapshot,
      children: {
        jobNumber: { enabled: false },
        customerName: { enabled: false },
        name: { enabled: false },
        siteAddress: { enabled: false },
      },
    });
  }
}
